import { render, staticRenderFns } from "./CategoriasPrestaciones.vue?vue&type=template&id=4892ed42&"
import script from "./CategoriasPrestaciones.vue?vue&type=script&lang=js&"
export * from "./CategoriasPrestaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports